module.exports = __webpack_public_path__ + "img/add-to-home-screen-apple-iphone.68472529.png";